"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./tooltip.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Tooltip = _ref => {
  let {
    className,
    title,
    titleTag = "h4",
    content,
    children,
    onClick
  } = _ref;
  const [tooltipVisible, setTooltipVisible] = (0, _react.useState)(false);
  const tooltipRef = (0, _react.useRef)(null);
  const buttonRef = (0, _react.useRef)(null);
  const TitleTag = titleTag;
  const showTooltip = () => {
    setTooltipVisible(true);
    if (onClick) {
      onClick();
    }
  };
  const hideTooltip = () => {
    setTooltipVisible(false);
  };
  const calculatePosition = () => {
    if (tooltipRef.current && buttonRef.current) {
      const tooltip = tooltipRef.current;
      const button = buttonRef.current;
      const {
        left: tooltipLeft
      } = tooltip.getBoundingClientRect();
      const computedStyles = window.getComputedStyle(tooltip);
      const maxWidth = parseInt(computedStyles.getPropertyValue("max-width"), 10);
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewportMargin = 32;
      const remainingWidth = viewportWidth - tooltipLeft;
      let tooltipWidth = maxWidth;
      if (viewportWidth < maxWidth) {
        tooltipWidth = viewportWidth - viewportMargin * 2;
        if (tooltipWidth > remainingWidth) {
          const overflow = tooltipWidth - remainingWidth;
          tooltip.style.left = "".concat(tooltip.offsetLeft - (overflow + viewportMargin), "px");
        } else {
          tooltip.style.left = "".concat(tooltip.offsetLeft, "px");
        }
      } else if (maxWidth > remainingWidth) {
        const overflow = maxWidth - remainingWidth;
        tooltip.style.left = "".concat(tooltip.offsetLeft - (overflow + viewportMargin), "px");
      } else {
        const offset = maxWidth / 2;
        if (offset + viewportMargin > tooltipLeft) {
          tooltip.style.left = "".concat(tooltip.offsetLeft, "px");
        } else {
          tooltip.style.left = "".concat(tooltip.offsetLeft - offset, "px");
        }
      }
      tooltip.style.width = "".concat(tooltipWidth, "px");
      tooltip.style.top = "".concat(button.offsetTop + button.offsetHeight, "px");
    }
  };
  (0, _react.useEffect)(() => {
    if (tooltipVisible) {
      calculatePosition();
      const handleClickOutside = event => {
        const clickedElement = event.target;
        const clickedElementIsTooltipTrigger = clickedElement === buttonRef.current || clickedElement.closest(".tooltip-trigger") === buttonRef.current;
        if (tooltipRef.current && !tooltipRef.current.contains(event.target) && !clickedElementIsTooltipTrigger) {
          hideTooltip();
        }
      };
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [tooltipVisible]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-container ".concat(className || "")
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "tooltip-trigger",
    onClick: showTooltip,
    "aria-label": "".concat(title || "", "tooltip"),
    ref: buttonRef
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa-regular fa-circle-info mr-3 mr-sm-2"
  }), children && children), tooltipVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip border border-teal-20",
    ref: tooltipRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-body text-default"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-title flex"
  }, title && /*#__PURE__*/_react.default.createElement(TitleTag, {
    className: "mr-2",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "ml-auto tooltip-close",
    onClick: hideTooltip
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa-regular fa-close"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-content mt-3 fs-small fw-400"
  }, content))));
};
exports.Tooltip = Tooltip;